import React from 'react'
import { NavLink } from 'react-router-dom';

const CardTeam = (props) => {
    return (
        <div className="wrapper__card-team">
            <div className="profile" style={{ height: 'fit-content' }}>
    <img src={props.data.img} alt="" />
</div>
            <div className="desc text-center d-flex flex-column align-items-center" style={{ gap: '8px' }}>
                <h4 className='medium font__size--24 text__24-1024 mb-0'>{props.data.name}</h4>
                <p className='normal font__size--14 text__14-1024 my-1'>{props.data.job}</p>
                <p className='bold font__size--20 text__14-1024 my-1 color__purple'>{props.data.price}</p>
                <NavLink
  to="/contact"
  className="medium font__size--14 text__14-1024 color__white btn btn__purple shadow w-100 rounded__50"
>
  Buy Book {props.data.btn}
</NavLink>
            </div>
        </div>
    )
}

export default CardTeam